import { PlacesAutocompleteOption } from "@sweatpals/react-ui-kit";

export class GooglePlacesAutocompleteService {
	public async getPlaces(request: google.maps.places.AutocompletionRequest): Promise<PlacesAutocompleteOption[]> {
		if (!google.maps?.places) {
			return [];
		}

		const autocompleteService = new google.maps.places.AutocompleteService();
		const { predictions } = await autocompleteService.getPlacePredictions(request);

		return predictions.map(prediction => ({
			id: prediction.place_id,
			description: prediction.description,
			formattedSuggestion: {
				mainText: prediction.structured_formatting.main_text,
				secondaryText: prediction.structured_formatting.secondary_text,
			},
		}));
	}
}
